let config = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "forwood-dlpocclient-dev-forwoodid",
    BATCH_PROCESS_BUCKET_NAME: "forwood-dlpocclient-dev-forwoodid-batch-user-process",
  },
  appSyncAPI: {
    REGION: "us-west-2",
    URL: "https://4v6oudmbnzathfkpbgan57fa3a.appsync-api.us-west-2.amazonaws.com/graphql",
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://e4nw87njc6.execute-api.us-west-2.amazonaws.com/env",
    USER_TOKEN_URL: "https://mmos819k0c.execute-api.us-west-2.amazonaws.com/prod",
  },
  configurationService: {
    URL: "https://config.dev.dlpocclient.forwoodsafety.com",
    WEBSOCKET: "wss://9ltq2u61yc.execute-api.us-west-2.amazonaws.com/dev",
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_8vUiuJXVp",
    IDENTITY_POOL_ID: "us-west-2:8b67aedf-c17b-4738-8d33-0e7cd1bc14d1",
    USERPOOL_HOSTED_DOMAIN: "forwood-dlpocclient-id-dev",
    USERPOOL_ADFS_CALLBACK_URL: "https://id.dev.dlpocclient.forwoodsafety.com",
    USERPOOL_ADFS_LOGOUT_URL: "https://id.dev.dlpocclient.forwoodsafety.com",
    AUTHENTICATED_ROLE_ARN: "arn:aws:iam::122458452253:role/dev-CA",
  },
  samlProvider: {
    NAME: "forwood",
    SUPPORTED_LIST: "forwood",
  },
  reactApp: {
    VERSION: "1.42.5",
    HOSTNAME: "id.dev.dlpocclient.forwoodsafety.com",
    ENV_NAME: "dev",
    COOKIE_DOMAIN: ".dev.dlpocclient.forwoodsafety.com",
    SECURE_PROTOCOL: true,
    FORWOOD_COMPANY_ID: "a542ae2b-6931-4307-8ad6-ae03c182c6ca",
    FORWOOD_HOMEPAGE_MICROFRONTEND_URL: "https://homepage.dev.dlpocclient.forwoodsafety.com",
  },
  USERPOOL_ADFS_LAUNCH_URL(clientId) {
    return 'https://'+this.cognito.USERPOOL_HOSTED_DOMAIN+'.auth.'+this.cognito.REGION+'.amazoncognito.com/authorize?redirect_uri='+this.cognito.USERPOOL_ADFS_CALLBACK_URL+'&response_type=code&client_id='+clientId;
  },
};

export default config;
